import React, {memo, useEffect, useState } from 'react'
import './TextArea.scss'

function TextArea({width, name, value="", placeholder, fullHeight, heading, disabled=false, onChange, row, maxLength, showCount}) {
  const [text, setText] = useState(value)

  useEffect(() => {
    if(value?.length)
      onChange?.(value)
  }, [])

  useEffect(()=>{
    setText(value || "")
  }, [value])


  return (
    <div className='text-area-custom' style={{width: width || '100%'}}>
      {heading && <div className="heading my-2 mt-3 h-100">{heading}</div>}
      <div className={`${fullHeight ? 'h-100': ''} input`}>
        <textarea 
        disabled={disabled}
        maxLength={maxLength}
        className={`${fullHeight ? 'h-100': ''}`}
          name={name} 
          placeholder={disabled ? "-" : placeholder}
          onChange={(e)=>{
            setText?.(e.target.value);
            onChange?.(e.target.value)
          }}
          value={text}
          {...(row && {rows: row})}
        >
        
        </textarea>
        {
          showCount &&
          <div className='show-count'>{text?.length}/{maxLength} </div>
        }
      </div>
    </div>
  )
}

export default memo(TextArea);